"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removalKeys = exports.items = exports.filters = void 0;
const effect_1 = require("effect");
const field_1 = require("../../openapi/field");
const metadata_1 = require("./metadata");
// Struct fields the admin and frontend metadata contracts both use. Kept out of
// the Shared index: they are fields, not schemas with an identifier.
exports.filters = (0, field_1.optionalString)('Comma-separated keys to return. Runtime keeps a key only when the stored value is truthy.');
exports.items = effect_1.Schema.propertySignature(effect_1.Schema.NonEmptyArray(metadata_1.KeyValueItem)).annotations({
    description: 'Metadata pairs to merge or overwrite (min 1)',
});
exports.removalKeys = effect_1.Schema.optionalWith(effect_1.Schema.Array(effect_1.Schema.String), { exact: true }).annotations({
    description: 'Keys to remove. A value without a positive length (omitted, null, an empty list, a number or an object) clears all metadata for the owner.',
});
//# sourceMappingURL=metadata-fields.js.map